// @Version: 1.0.0
import { Injectable } from '@angular/core';

@Injectable({
   providedIn: 'root'
})
export class FieldItemCombofieldService {

   constructor () { }

   public setSelections (value:string): string[] {
      return typeof value == 'string' ? value.split(/;/) : [];
   }
}
